/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { Locale } from '../../../../core/locale/Locale';
import { LocaleKeys } from '../../../../core/locale/LocaleKeys';
import { VuLogger } from '../../../../core/logging';
import { Log } from '../../../../core/logging/Log';
import { ScreenTaskControllerTypes } from '../../../../core/navigation/ScreenTaskControllerTypes';
import { AiringPreviewUtils } from '../../../../core/videoplayer/utils';
import { VideoPlaybackController } from '../../../../core/videoplayer/VideoPlaybackController';
import { OverlayTypes } from '../../../overlay/OverlayTypes';
import {
    hideOverlayDialog,
    showOverlayDialog,
} from '../../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../../screens/screens.reducers';
import { changeAudioTrack } from '../../videoplayer.reducers';

const TAG = 'audiotrackoverlay';
const GLOBAL_MOUSE_TRAP = 'AudioTrackOverlay';

export const showAudioTrackOverlay = () => (dispatch: Function) => {
    const audioTracks = VideoPlaybackController.getInstance().getAudioTracks();
    const { airingOffers, offerPreview, vodOfferPreview } = VideoPlaybackController.getInstance().getMetadata();
    const dataFormatter = new AiringPreviewUtils(airingOffers, offerPreview || vodOfferPreview);
    const audioSubtitlePopupTitle = dataFormatter.getSeasonEpisodeTitle();
    if (audioTracks.length > 0) {
        const overlayDialogProps: IOverlayDialog = {
            hasDimmer: false,
            hasSeperator: false,
            options: audioTracks,
            title: Locale.getString(LocaleKeys.AUDIO_TRACK_OVERLAY_TITLE),
            subtitle: audioSubtitlePopupTitle,
            overlayType: OverlayTypes.AUDIO_TRACK,
            mouseTrapValue: GLOBAL_MOUSE_TRAP,
        };
        dispatch(showOverlayDialog(overlayDialogProps));
        Diagnostics.debug(
            TAG,
            'showAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY,
            '}',
        );
        Log.d(
            TAG,
            'showAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY,
            '}',
        );
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY));
    }
};

export const onKeyBackAudioTrackOverlay =
    (calledFromOnTrackSelect?: boolean) => (dispatch: Function, getState: Function) => {
        const { isOverlayDialogActive } = getState().overlayDialog;

        if (isOverlayDialogActive) {
            dispatch(hideOverlayDialog());
        }
        Log.d(
            TAG,
            'onKeyBackAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );
        Diagnostics.debug(
            TAG,
            'onKeyBackAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );

        if (!calledFromOnTrackSelect) {
            VuLogger.logUserActionEvent({
                actionName: VuLogger.UserActionEventActionName.AUDIO_LANGUAGE,
                action: VuLogger.UserActionEventAction.CANCEL,
                screen: VuLogger.UserActionEventScreen.OVERLAYS,
                selection: VideoPlaybackController.getInstance().getSelectedAudioTrack(),
            });
        }
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS));
    };

export const onKeyOkAudioTrackOverlay = () => (dispatch: Function, getState: Function) => {
    const { isOverlayDialogActive } = getState().overlayDialog;
    const { verticalPosition } = getState().overlayHighlight;
    const { value } = getState().inputFactory;

    // if value is equal to GLOBAL_MOUSE_TRAP then it means cursor is not on the overlay options
    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(onKeyBackAudioTrackOverlay(true));
        return;
    }

    if (isOverlayDialogActive) {
        dispatch(onTrackSelect(verticalPosition));
    }
};

export const onTrackSelect = (selectedIndex: number) => (dispatch: Function) => {
    dispatch(changeAudioTrack(selectedIndex));
    dispatch(onKeyBackAudioTrackOverlay(true));
};
